import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const navigateTo = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-sm py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <button
          onClick={() => navigateTo('/')}
          className="text-white font-bold text-2xl tracking-wider cursor-pointer hover:text-red-500 transition-colors duration-300"
        >
          BOND BOXING
        </button>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
          <button
            onClick={() => navigateTo('/')}
            className={`text-white hover:text-red-500 transition-colors duration-300 font-medium tracking-wide ${
              location.pathname === '/' ? 'text-red-500' : ''
            }`}
          >
            HOME
          </button>
          <button
            onClick={() => navigateTo('/gym')}
            className={`text-white hover:text-red-500 transition-colors duration-300 font-medium tracking-wide ${
              location.pathname === '/gym' ? 'text-red-500' : ''
            }`}
          >
            GYM
          </button>
          <button
            onClick={() => navigateTo('/events')}
            className={`text-white hover:text-red-500 transition-colors duration-300 font-medium tracking-wide ${
              location.pathname === '/events' ? 'text-red-500' : ''
            }`}
          >
            EVENTS
          </button>
          <button
            onClick={() => navigateTo('/amateur')}
            className={`text-white hover:text-red-500 transition-colors duration-300 font-medium tracking-wide ${
              location.pathname === '/amateur' ? 'text-red-500' : ''
            }`}
          >
            125 CLUB
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="text-white hover:text-red-500 transition-colors duration-300 font-medium tracking-wide"
          >
            CONTACT
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 font-medium tracking-wide transition-all duration-300 border border-red-600 hover:border-red-700"
          >
            JOIN NOW
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 z-60 bg-black/95 pt-24">
          <div className="container mx-auto px-6 py-6 flex flex-col space-y-6">
            <button
              onClick={() => navigateTo('/')}
              className={`text-white hover:text-red-500 transition-colors duration-300 font-medium tracking-wide text-left ${
                location.pathname === '/' ? 'text-red-500' : ''
              }`}
            >
              HOME
            </button>
            <button
              onClick={() => navigateTo('/gym')}
              className={`text-white hover:text-red-500 transition-colors duration-300 font-medium tracking-wide text-left ${
                location.pathname === '/gym' ? 'text-red-500' : ''
              }`}
            >
              GYM
            </button>
            <button
              onClick={() => navigateTo('/events')}
              className={`text-white hover:text-red-500 transition-colors duration-300 font-medium tracking-wide text-left ${
                location.pathname === '/events' ? 'text-red-500' : ''
              }`}
            >
              EVENTS
            </button>
            <button
              onClick={() => navigateTo('/amateur')}
              className={`text-white hover:text-red-500 transition-colors duration-300 font-medium tracking-wide text-left ${
                location.pathname === '/amateur' ? 'text-red-500' : ''
              }`}
            >
            125 CLUB
          </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white hover:text-red-500 transition-colors duration-300 font-medium tracking-wide text-left"
            >
              CONTACT
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 font-medium tracking-wide transition-all duration-300 border border-red-600 hover:border-red-700 text-center"
            >
              JOIN NOW
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
